// Shown by the Sentry ErrorBoundary when a render error is caught, instead of a blank screen. The error itself
// has already been reported to Sentry (when a DSN is configured).
export function ErrorFallback() {
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <h1 style={{ fontSize: 20, marginBottom: 8 }}>Something went wrong</h1>
        <p style={{ opacity: 0.7, marginBottom: 20, lineHeight: 1.5 }}>
          An unexpected error occurred. It has been reported to our team. Try reloading the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid var(--border, #ccc)', cursor: 'pointer', background: 'var(--primary, #2563d9)', color: '#fff' }}
        >
          Reload
        </button>
      </div>
    </div>
  )
}
